/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../../node/read-file-sync.node (ignored)
// module id = 5
// module chunks = main